import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import FileContext from "../../Files/Context/Index";

import PreviewListComponent from "./PreviewListComponent";
import PreviewComponent from "./PreviewComponent";
import { fetchFileAndConvertToBase64 } from "../../../Shared/Utils/filesUtils";

import { getFilesApi } from "../../../Shared/Api/GetFiles";

export default function FilesList({ model_id, model_type, mime_type }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [filters, setFilters] = useState({});

  const fetchFiles = async () => {
    let response = await getFilesApi({
      ...filters,
    });
    if (response.result === "success") {
      setFiles(response.data?.items);
    }
  };
  const handleFileClick = (file) => {
    if (file?.data == undefined) {
      fetchFileAndConvertToBase64(file, handleConverFile);
    } else {
      setSelectedFile(file);
      setModalOpen(true);
    }
  };
  const handleConverFile = async (file) => {
    setSelectedFile(file);
    setModalOpen(true);
  };
  useEffect(() => {
    setFilters({
      ...filters,
      model_id,
      model_type,
      mime_type,
    });
  }, [model_id, model_type, mime_type]);

  useEffect(() => {
    if (filters?.model_id && filters?.model_type) {
      fetchFiles();
    }
  }, [filters]);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  useEffect(() => {
    return () => {
      setFiles([]);
    };
  }, []);

  return (
    <>
      <PreviewListComponent
        files={files}
        handleFileClick={handleFileClick}
        readOnly={true}
      ></PreviewListComponent>
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalBody>
          <PreviewComponent selectedFile={selectedFile}></PreviewComponent>
        </ModalBody>
      </Modal>
    </>
  );
}
